import React, { useEffect, useState } from "react";
import { CgSpinner } from "react-icons/cg";
import {
  savePreviousState,
  validateChangeAtButton,
} from "../../../../utils/EditChangeValidate";

import { useDispatch } from "react-redux";
import { setAppError } from "../../../../store/userSlice";
import { AiOutlineInfoCircle } from "react-icons/ai";
export default function AddEditFormCompany({
  submitForm,
  submitFormLoading,
  cancelForm,
  loadedValues = {},
  form = [],
  logo,
  setLogo,
  headerImage,
  footerImage,
  setHeaderImage,
  setFooterImage,
  headerPreview,
  footerPreview,
  setHeaderPreview,
  setFooterPreview,
}) {
  const headerSize = { width: 3264, height: 489 };
  const footerSize = { width: 3264, height: 426 };
  const dispatch = useDispatch();
  // const [logo, setLogo] = useState("");
  // const [headerImage, setHeaderImage] = useState("");
  // const [footerImage, setFooterImage] = useState("");

  const [prevState, setPrevState] = useState([]);
  const [allowEdit, setAllowEdit] = useState(!loadedValues);
  const [imageValidation, setImageValidation] = useState(true);
  const [headerValidation, setHeaderValidation] = useState(true);
  const [footerValidation, setFooterValidation] = useState(true);

  const [initialHeaderImage, setCurrentHeaderImage] = useState(headerImage);
  const [initialFoooterImage, setCurrentFooterImage] = useState(footerImage);

  useEffect(() => {
    if (loadedValues) {
      setPrevState(savePreviousState(form));
    }
  }, []);

  useEffect(() => {
    let valid = true;
    if (prevState?.length > 0) {
      valid = validateChangeAtButton(prevState, form);
    }
    if (
      valid ||
      logo?.name ||
      headerImage != initialHeaderImage ||
      footerImage != initialFoooterImage
    )
      setAllowEdit((p) => true);
    else setAllowEdit((p) => false);
  }, [form, logo]);

  function getImageResolution(file) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = URL.createObjectURL(file);
      img.onload = () => {
        resolve({ width: img.width, height: img.height });
      };
      img.onerror = (error) => {
        reject(error);
      };
    });
  }

  console.log(headerImage, footerImage);

  const checkHeaderValidation = async (image) => {
    const { width, height } = await getImageResolution(image);
    if (width == headerSize.width && height == headerSize.height) {
      setHeaderImage(image);
      setHeaderPreview(image);
    } else {
      setHeaderImage(initialHeaderImage);
      console.log("get here");
      dispatch(
        setAppError({
          msg: "Header resolution must be 3264x489",
        })
      );
    }
  };

  const checkFooterValidation = async (image) => {
    const { width, height } = await getImageResolution(image);
    if (width == footerSize.width && height == footerSize.height) {
      setFooterImage(image);
      setFooterPreview(image);
    } else {
      setFooterImage(initialFoooterImage);
      console.log("get here");
      dispatch(
        setAppError({
          msg: "Footer resolution must be 3264x426",
        })
      );
    }
  };

  // useEffect(() => {
  //   let headerValidation = true;
  //   let footerValidation = true;
  //   console.log(headerImage, footerImage);
  //   if (!headerImage && !footerImage) {
  //     setImageValidation(true);
  //   }
  //   // let checkValidation
  //   if (headerImage || footerImage) {
  //     const headerSize = { width: 3264, height: 489 };
  //     const footerSize = { width: 3264, height: 426 };
  //     if (headerImage) {
  //       console.log("header running");
  //       getImageResolution(headerImage).then(({ width, height }) => {
  //         if (width == headerSize.width && height == headerSize.height) {
  //           headerValidation = true;
  //         } else {
  //           console.log("get here");
  //           headerValidation = false;
  //           dispatch(
  //             setAppError({
  //               msg: "Header resolution must be 3264x489",
  //             })
  //           );
  //         }
  //         console.log(headerValidation, footerValidation, "header");
  //         if (!headerValidation || !footerValidation) {
  //           setImageValidation(false);
  //         } else {
  //           setImageValidation(true);
  //         }
  //       });
  //     }
  //     if (footerImage) {
  //       console.log("footer running");
  //       getImageResolution(footerImage).then(({ width, height }) => {
  //         if (width == footerSize.width && height == footerSize.height) {
  //           footerValidation = true;
  //         } else {
  //           footerValidation = false;
  //           dispatch(
  //             setAppError({
  //               msg: "Footer resolution must be 3264x426",
  //             })
  //           );
  //         }
  //         console.log(headerValidation, footerValidation, "footer");
  //         if (!headerValidation || !footerValidation) {
  //           setImageValidation(false);
  //         } else {
  //           setImageValidation(true);
  //         }
  //       });
  //     }
  //   }
  // }, [headerImage, footerImage]);

  return (
    <div className="flex justify-center  items-center bg-white dark:bg-dark rounded-md py-5">
      <form
        method="POST"
        onSubmit={(event) => submitForm(event, logo, headerImage, footerImage)}
        className="w-full  uppercase flex flex-col items-center justify-center"
      >
        {form.map((elem, index) => (
          <>
            {elem.type == "select" ? (
              <div
                key={index}
                className="flex flex-col p-2 gap-1 w-full max-w-md "
              >
                <label htmlFor={`addOrEdit-${elem?.name}`} className="text-xs ">
                  {elem.text}
                </label>
                <select
                  placeholder={`Enter ${elem.text}`}
                  required
                  className="border-[1px] uppercase border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
                  onChange={(e) => {
                    const errorElem = document.getElementById(
                      `company-${elem.columnName}`
                    );
                    errorElem.style.display = "none";
                    elem.update(e.target.value);
                  }}
                  value={elem.value}
                >
                  <option value="" hidden>
                    Select an option
                  </option>
                  {elem?.options?.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>

                <p
                  id={`company-${elem.columnName}`}
                  className="hidden w-full h-5 bg-red/5 text-red text-xs"
                ></p>
              </div>
            ) : (
              <>
                <div
                  key={index}
                  className="flex flex-col p-2 gap-1 w-full max-w-md"
                >
                  <label
                    htmlFor={`addOrEdit-${elem?.name}`}
                    className="text-xs "
                  >
                    {elem.text}
                  </label>

                  {elem.type === "textarea" ? (
                    <textarea
                      name={elem.name}
                      id={`addOrEdit-${elem.name}`}
                      cols="10"
                      rows="4"
                      placeholder={`Enter ${elem.text}`}
                      required
                      className="border-[1px] border-border uppercase dark:bg-dark rounded-md p-1 py-2 text-xs"
                      defaultValue={elem.value}
                      onChange={(e) => {
                        const errorElem = document.getElementById(
                          `company-${elem.columnName}`
                        );
                        errorElem.style.display = "none";
                        elem.update(e.target.value.toUpperCase());
                      }}
                    ></textarea>
                  ) : (
                    <input
                      type={elem.type}
                      name={elem.name}
                      id={`addOrEdit-${elem.name}`}
                      placeholder={`Enter ${elem.text}`}
                      required={!elem.notRequired}
                      className="border-[1px] border-border uppercase dark:bg-dark rounded-md p-1 py-2 text-xs"
                      defaultValue={elem.value}
                      onChange={(e) => {
                        const errorElem = document.getElementById(
                          `company-${elem.columnName}`
                        );
                        errorElem.style.display = "none";
                        if (elem.type === "text" || elem.type === "email")
                          elem.update(e.target.value.toUpperCase());
                        else elem.update(e.target.value);
                      }}
                    />
                  )}

                  <p
                    id={`company-${elem.columnName}`}
                    className="hidden w-full h-5 bg-red/5 text-red text-xs"
                  ></p>
                </div>
              </>
            )}
          </>
        ))}
        <div className="flex flex-col p-2 gap-1 w-full max-w-md">
          <label htmlFor={`addOrEdit-file`} className="text-xs ">
            Company Logo
          </label>
          <div className="w-full flex  justify-between ">
            <input
              type="file"
              name="file"
              id={`addOrEdit-file`}
              // required
              className="border-[1px] border-border uppercase dark:bg-dark rounded-md p-1 py-2 text-xs "
              accept="image/png, image/jpg, image/jpeg"
              onChange={(e) => {
                const errorElem = document.getElementById(`company-logo`);
                errorElem.style.display = "none";
                setLogo(e.target.files[0]);
              }}
            />

            {logo && (
              <>
                {!logo?.name ? (
                  <img
                    src={logo}
                    alt="logo"
                    className="max-h-8 max-w-full mb-3"
                  />
                ) : (
                  <img
                    src={URL.createObjectURL(logo)}
                    alt="logo"
                    className="max-h-8 max-w-full mb-3"
                  />
                )}
              </>
            )}
          </div>

          <p
            id={`company-logo`}
            className="hidden w-full h-5 bg-red/5 text-red text-xs"
          ></p>
        </div>
        <div className="flex flex-col p-2 gap-1 w-full max-w-md">
          <label htmlFor={`addOrEdit-file`} className="text-xs ">
            Company Header Image
          </label>
          <p
            id={`company-header`}
            className="flex gap-1 items-center w-full h-5 text-gray text-xs"
          >
            <AiOutlineInfoCircle />
            Header resolution must be 3264x489
          </p>
          <input
            type="file"
            name="file"
            id={`addOrEdit-file`}
            // required
            className="border-[1px]  border-border uppercase dark:bg-dark rounded-md p-1 py-2 text-xs"
            accept="image/jpg, image/jpeg"
            onChange={async (e) => {
              await checkHeaderValidation(e.target.files[0]);
            }}
          />
          {headerPreview && (
            <>
              {!headerPreview?.name ? (
                <img
                  src={headerPreview}
                  alt="logo"
                  className="max-h-8 max-w-full mb-3"
                />
              ) : (
                <img
                  src={URL.createObjectURL(headerPreview)}
                  alt="logo"
                  className="max-h-8 max-w-full mb-3"
                />
              )}
            </>
          )}
        </div>
        <div className="flex flex-col p-2 gap-1 w-full max-w-md">
          <label htmlFor={`addOrEdit-file`} className="text-xs ">
            Company Footer Image
          </label>
          <p
            id={`company-footer`}
            className="flex gap-1 items-center w-full h-5 text-gray  text-xs"
          >
            <AiOutlineInfoCircle />
            Footer resolution must be 3264x426
          </p>
          <input
            type="file"
            name="file"
            id={`addOrEdit-file`}
            // required
            className="border-[1px] border-border uppercase dark:bg-dark rounded-md p-1 py-2 text-xs"
            accept="image/jpg, image/jpeg"
            onChange={async (e) => {
              await checkFooterValidation(e.target.files[0]);
            }}
          />
          {footerPreview && (
            <>
              {!footerPreview?.name ? (
                <img
                  src={footerPreview}
                  alt="logo"
                  className="max-h-8 max-w-full mb-3"
                />
              ) : (
                <img
                  src={URL.createObjectURL(footerPreview)}
                  alt="logo"
                  className="max-h-8 max-w-full mb-3"
                />
              )}
            </>
          )}
        </div>

        <div className="p-2  w-full max-w-md flex gap-3">
          <button
            className="ring-1 ring-black uppercase dark:ring-red w-full text-xs dark:text-white rounded-md py-2 flex justify-center items-center gap-2"
            type="button"
            disabled={submitFormLoading}
            onClick={cancelForm}
          >
            <p>Cancel</p>
          </button>
          {allowEdit ? (
            <button
              className="bg-black uppercase dark:bg-red w-full text-xs text-white rounded-md py-2 flex justify-center items-center gap-2"
              type="submit"
              disabled={submitFormLoading}
            >
              <p>Submit</p>
              {submitFormLoading && <CgSpinner className="animate-spin" />}
            </button>
          ) : (
            <button
              disabled
              className="bg-gray uppercase cursor-not-allowed dark:bg-red w-full text-xs text-white rounded-md py-2 flex justify-center items-center gap-2"
              title="no changes made"
            >
              <p>Submit</p>
            </button>
          )}
        </div>
      </form>
    </div>
  );
}
